import { motion } from "framer-motion";
import { CheckCircle2, Circle } from "lucide-react";

const phases = [
  {
    phase: "Phase 01 — Spark",
    status: "done",
    items: ["Concept & mission defined", "Smart contract draft", "Community channels launched"],
  },
  {
    phase: "Phase 02 — Ignite",
    status: "active",
    items: ["Fair public presale", "Security audit", "First reforestation partner signed"],
  },
  {
    phase: "Phase 03 — Regrow",
    status: "next",
    items: ["DEX listing & liquidity lock", "On-chain Reforestation Fund goes live", "First 1M trees funded"],
  },
  {
    phase: "Phase 04 — Restore",
    status: "next",
    items: ["DAO governance for grants", "Community rebuild program", "Global wildfire response network"],
  },
];

export default function Roadmap() {
  return (
    <section id="roadmap" className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto">
      <div className="max-w-2xl mb-16">
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-ember">Roadmap</span>
        <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-display font-bold tracking-tight">
          From the first spark to full restoration.
        </h2>
      </div>

      <div className="relative">
        <div className="absolute left-[15px] top-2 bottom-2 w-px bg-gradient-to-b from-ember via-ember/40 to-transparent" />
        <div className="space-y-12">
          {phases.map((p, i) => {
            const done = p.status === "done";
            const active = p.status === "active";
            return (
              <motion.div
                key={p.phase}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="relative pl-12"
                data-testid={`roadmap-phase-${i + 1}`}
              >
                <div className="absolute left-0 top-1">
                  {done ? (
                    <CheckCircle2 className="w-8 h-8 text-ember bg-background" />
                  ) : (
                    <Circle className={`w-8 h-8 bg-background ${active ? "text-ember animate-ember" : "text-muted-foreground"}`} />
                  )}
                </div>
                <div className="flex items-center gap-3 mb-3">
                  <h3 className="font-display font-bold text-2xl">{p.phase}</h3>
                  {active && (
                    <span className="font-mono text-[10px] uppercase tracking-wider text-ember border border-ember/40 px-2 py-1">
                      In Progress
                    </span>
                  )}
                </div>
                <ul className="space-y-2">
                  {p.items.map((it) => (
                    <li key={it} className="text-muted-foreground flex items-center gap-2">
                      <span className="w-1 h-1 bg-ember" />
                      {it}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
